import React, { useState } from 'react';
import './CSM.scss'
import MainButton from '../../../components/MainButton/MainButton';

export default function CSM() {
  const [image, setImage] = useState(null);
  const [coordinates, setCoordinates] = useState(null);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
      setCoordinates(null);
    }
  };

  const handleImageClick = (event) => {
    const rect = event.target.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const newCoordinates = { x: Math.round(x), y: Math.round(y) };
    setCoordinates(newCoordinates);

    const coordsText = `[${newCoordinates.x}, ${newCoordinates.y}]`;
    navigator.clipboard.writeText(coordsText).catch((err) => {
      console.error('Error copying cords:', err);
    });
  };

  return (
    <>
      <div className='wrapper'>
        <MainButton title={"🡠 CSP"} link={"/create-svg-polygon"}/>
        <div className="info">
          <h1>Create svg marker</h1>
          <div className="info-span">
            <span>1. Select render image</span>
            <span>2. Use zoom (ctrl + mouse wheel)</span>
            <span>3. Click on image</span>
            <span>4. Coordinates already coopying in to clipboard</span>
          </div>
        </div>
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
        />
        <div className="cords">
          <span>Coordinates: </span>
          <span>{coordinates ? `{x:${coordinates.x}, y:${coordinates.y}}` : 'No coordinates yet'}</span>
        </div>
        {image && (
          <div
           className='img-container'
           style={{position: 'relative'}}>
            <img
              src={image}
              alt="Selected"
              onClick={handleImageClick}
            />
            {coordinates && (
              <svg
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  pointerEvents: 'none',
                }}
              >
                <circle
                  cx={coordinates.x}
                  cy={coordinates.y}
                  r="5"
                  fill="red"
                />
              </svg>
            )}
          </div>
        )}
      </div>
    </>
  );
}